// Configuration API
const API_BASE_URL = import.meta.env.VITE_REACT_APP_API_EP_URI;

export interface ChartPoint {
  x: string;
  y: number;
}

// Courbe calculée par le serveur (voir api/main/services/charts_service.py) :
// 'result' = un point par résultat d'un binôme, 'project' = un binôme du groupe TD, 'mean' = moyenne
export interface ChartSeries {
  kind: 'result' | 'project' | 'mean';
  indicator: string;
  project_group_id?: number;
  name?: string;
  points: ChartPoint[];
}

export interface ChartSeriesResponse {
  series: ChartSeries[];
  dates: { min: string | null; max: string | null };
}

class ChartsService {
  async getSeries(params: { cycles: number[]; indicators: string[]; tdGroup?: string; projectGroupId?: string },
                  accessToken: string, signal?: AbortSignal): Promise<ChartSeriesResponse> {
    const query = new URLSearchParams({ cycles: params.cycles.join(','), indicators: params.indicators.join(',') });
    if (params.tdGroup) query.set('td_group', params.tdGroup);
    if (params.projectGroupId) query.set('project_group_id', params.projectGroupId);
    const response = await fetch(`${API_BASE_URL}/charts/series?${query.toString()}`, {
      headers: { 'Authorization': `Bearer ${accessToken}` },
      signal,
    });
    const json = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(json.message || `HTTP error! status: ${response.status}`);
    }
    return json;
  }
}

export const chartsService = new ChartsService();
